export default __webpack_public_path__ + "5ae3fbc004eda6084c570b6d925b3d30.webp";